import { render } from "./CallLink.vue?vue&type=template&id=002c2c60&ts=true"
import script from "./CallLink.vue?vue&type=script&lang=ts"
export * from "./CallLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__